
import { Component, Vue } from "vue-property-decorator";
import FeedbackDiagramComponent from "../components/FeedbackDiagramComponent.vue";

@Component({
	components: {
		"feedback-diagram-component": FeedbackDiagramComponent,
	},
})
export default class Home extends Vue {
	private close() {
		parent.postMessage("close", "*");
	}
}
